'use strict';

const axios = require('axios');
const gtm = require('./modules/google').tagManager;

function callwhitelist() {
    const url = Urls.sendWhitelistingEmail;
    const signupConfirm = $('.js-b2b-signup');
    const $form = $('#whitelist-form');

    $form.on('submit', function(e) {
        e.preventDefault();
        hashCustomerEmail(Urls.hashCustomerEmail,$form).then((res) => {
            if (whitelistFormValidity(res)){
                //show confirmation signup
                axios.post(url, {
                    timeout: 200000,
                    params: {
                        name: $form[0]['dwfrm_b2bwhitelist_firstname'].value,
                        surname: $form[0]['dwfrm_b2bwhitelist_lastname'].value,
                        email: $form[0]['dwfrm_b2bwhitelist_email'].value,
                        phone: $form[0]['dwfrm_b2bwhitelist_phone'].value,
                        companyName: $form[0]['dwfrm_b2bwhitelist_companyname'].value,
                        vat: $form[0]['dwfrm_b2bwhitelist_vat'].value,
                        business: $form[0]['dwfrm_b2bwhitelist_business'].value,
                        question: $form[0]['dwfrm_b2bwhitelist_question'].value
                    }
                }).then(() => {
                    signupConfirm.addClass('show');
                    formSubmitAnalytics(res);
                }).catch((e) => {
                    console.log('Your whitelist request could not be sent.', e);
                });
            }
        });
    });
}

async function hashCustomerEmail(url,form) {
    const data = await axios.post(url, {
        params: {
            email: form[0]['dwfrm_b2bwhitelist_email'].value
        }
    });
    const result = data.data.hashedEmail;
    return result;
}

function formSubmitAnalytics(hashedEmail) {
    gtm.pushDataLayerEvent({
        'event': 'form_submit',
        click_target: 'request proposal',
        'email': hashedEmail
    });
}

function formSubmitErrorAnalytics(hashedMail) {
    gtm.pushDataLayerEvent({
        'event': 'form_field_error',
        'email': hashedMail,
        'error_type': 'form validation error',
        'error_message': 'please enter valid email',
        'error_code': '404'
    });
}

function resetPlaceholderValue() {
    const inputFields = $('.js-b2b-input');

    inputFields.each(function() {
        $(this).on('focus', () => {
            $(this).addClass('focus');
        });

        $(this).on('focusout', () => {
            $(this).removeClass('focus');
        });
    });
}

function whitelistFormValidity(hashedMail) { //Find all active error validations
    let validation = true;
    const form = {
        name: $('#dwfrm_b2bwhitelist_firstname-error'),
        surname: $('#dwfrm_b2bwhitelist_lastname-error'),
        email: $('#dwfrm_b2bwhitelist_email-error'),
        phone: $('#dwfrm_b2bwhitelist_phone-error'),
        companyName: $('#dwfrm_b2bwhitelist_companyname-error'),
        vat: $('#dwfrm_b2bwhitelist_vat-error'),
        business: $('#dwfrm_b2bwhitelist_business-error')
    };
    Object.keys(form).forEach(function(element) {
        if (form[element].length) {
            validation = false;
        }
    });
    if (validation == false){
        formSubmitErrorAnalytics(hashedMail);
    }
    return validation;
}

const whitelist = {
    init: () => {
        resetPlaceholderValue();
        callwhitelist();
    }
};

module.exports = whitelist;
